import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight, Sparkles } from "lucide-react";
import { api, getResults } from "@/lib/api";
import { CATEGORIES } from "@/lib/data";

export default function Resources() {
  const nav = useNavigate();
  const r = getResults();
  const [byCat, setByCat] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/resources").then((res) => {
      const map = {};
      (res.data.items || []).forEach((it) => {
        (map[it.category] = map[it.category] || []).push(it);
      });
      setByCat(map);
    }).finally(() => setLoading(false));
  }, []);

  if (!r) {
    return (
      <div className="text-center py-24">
        <p className="text-neutral-400">Henüz test sonucun yok.</p>
        <button onClick={() => nav("/test")} className="btn-primary mt-6">Testi Başlat</button>
      </div>
    );
  }
  if (loading) return <div className="text-center py-24 text-neutral-500">Yükleniyor...</div>;

  const dev = [...CATEGORIES]
    .map((c) => ({ ...c, score: r.scores[c.key] }))
    .sort((a, b) => a.score - b.score)
    .slice(0, 3);
  const cards = dev.flatMap((d) => (byCat[d.key] || []).slice(0, 2).map((res) => ({ ...res, cat: d })));

  return (
    <div data-testid="resources-page">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
        <div className="lg:col-span-7">
          <h1 className="text-5xl md:text-6xl font-semibold tracking-tight h-gradient">Sana Özel Öneriler</h1>
          <p className="mt-5 text-neutral-400 max-w-xl">En çok gelişime açık alanlarına göre ücretsiz kaynakları senin için seçtik.</p>
        </div>
        <div className="lg:col-span-5 glass p-6">
          <div className="text-xs uppercase tracking-[0.15em] text-neutral-500 mb-4">En Çok İhtiyacın Olan Alanlar</div>
          <div className="space-y-3">
            {dev.map((d) => {
              const Icon = Icons[d.icon] || Icons.Circle;
              return (
                <div key={d.key} className="flex items-center gap-3 rounded-xl border border-white/8 px-3 py-2.5">
                  <Icon size={16} className="text-neutral-300" />
                  <div className="flex-1 text-sm text-neutral-200">{d.label}</div>
                  <div className="w-28 score-bar"><div style={{ width: `${d.score}%` }} /></div>
                  <span className="text-xs text-neutral-400 w-12 text-right">{d.score}/100</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
        {cards.map((c, i) => {
          const Icon = Icons[c.cat.icon] || Icons.BookOpen;
          return (
            <div key={c.id} className="glass p-7 flex flex-col" data-testid={`resource-card-${i}`}>
              <span className="self-start px-3 py-1 rounded-full border border-white/12 text-[10px] uppercase tracking-[0.15em] text-neutral-300">Ücretsiz</span>
              <Icon className="text-white mt-6 drop-shadow-[0_0_12px_rgba(255,255,255,0.4)]" size={40} />
              <h3 className="text-xl font-semibold mt-5 text-white">{c.title}</h3>
              <p className="mt-2 text-sm text-neutral-400 leading-relaxed flex-1">{c.description}</p>
              <Link to={`/kaynaklar/${c.id}`} className="btn-primary mt-5 inline-flex items-center justify-center gap-2 text-sm" data-testid={`resource-open-${i}`}>
                Kaynağı Aç <ArrowRight size={14} />
              </Link>
            </div>
          );
        })}
        {cards.length === 0 && (
          <div className="col-span-full text-center text-neutral-500 py-12">Bu kategoriler için kaynak henüz yok.</div>
        )}
      </div>

      <div className="glass mt-10 p-7 flex flex-col md:flex-row items-center justify-between gap-5">
        <div className="flex items-center gap-4">
          <Sparkles className="text-white" />
          <p className="text-neutral-200">Şimdi bu kaynaklarla başla, ardından sana uygun kitabı seç.</p>
        </div>
        <button onClick={() => nav("/kitaplar")} className="btn-primary inline-flex items-center gap-2" data-testid="go-to-books">
          Kitaplara Göz At <ArrowRight size={16} />
        </button>
      </div>

      <div className="glass mt-6 p-7 flex flex-col md:flex-row items-center justify-between gap-5">
        <div>
          <h3 className="text-lg font-semibold text-white">Tüm ücretsiz kaynaklara eriş</h3>
          <p className="text-neutral-400 text-sm mt-1">10 yaşam alanında hazırladığımız tüm rehber, checklist ve mini planları incele.</p>
        </div>
        <button onClick={() => nav("/kaynaklar")} className="btn-secondary inline-flex items-center gap-2" data-testid="go-all-resources">
          Tüm Kaynaklar <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
}
